import { useRef } from 'react';

import useGsapSection from '../../hooks/useGsapSection';

import useGsapInView from '../../hooks/useGsapInView';

import { BlurSplitText, ScrambleReveal, ClipRevealText } from '../TextEffects';

import { ABOUT_DISCIPLINES, ABOUT_FACTS } from '../../data/about';

import ContactTrigger from '../ContactTrigger';

import './AboutSection.css';



const bio = [

  'Independent since 2019, collaborating with agencies, studios and brands across Europe and the Middle East.',

  'I work across graphic design, web development, 3D and AI-driven production. One person, full process.',

  'One person who understands both design and development.',

];


const AboutSection = () => {

  const ref = useRef(null);

  const titleRef = useRef(null);

  const inView = useGsapSection(ref);

  const titleInView = useGsapInView(titleRef);



  return (

    <section

      id="about-story"

      ref={ref}

      className="about"

      data-testid="about-section"

    >

      <div className="about-strip">

        <span className="about-strip-left gsap-reveal">

          <span className="about-strip-num">(005)</span>

          <span className="about-strip-divider" />

          <ClipRevealText text="My Story" delay={0.1} externalInView={inView} />

        </span>

        <span className="about-strip-right gsap-reveal">

          <ScrambleReveal text="— Andrea Fagioli" delay={0.2} externalInView={inView} />

        </span>

      </div>



      <h2 ref={titleRef} className="about-statement">

        <span className="about-statement-line">

          <BlurSplitText

            text="I design and build"

            as="span"

            delay={0.15}

            stagger={0.06}

            externalInView={titleInView}

          />

        </span>

        <span className="about-statement-line">

          <BlurSplitText

            text="digital work that holds up"

            as="span"

            delay={0.3}

            stagger={0.06}

            externalInView={titleInView}

          />

        </span>

        <span className="about-statement-line">

          <BlurSplitText

            text="across brand, web and AI."

            as="span"

            delay={0.45}

            stagger={0.06}

            externalInView={titleInView}

          />

        </span>

      </h2>



      <div className="about-grid gsap-reveal">

        <div className="about-col about-col-disciplines">

          <ScrambleReveal text="— Disciplines" className="about-col-label" delay={0.1} externalInView={inView} />

          <ul className="about-disciplines">

            {ABOUT_DISCIPLINES.map((d) => (

              <li key={d} className="about-discipline">

                <span className="about-discipline-dot" aria-hidden="true" />

                {d}

              </li>

            ))}

          </ul>

        </div>



        <div className="about-col about-col-bio">

          <ScrambleReveal text="— Bio" className="about-col-label" delay={0.15} externalInView={inView} />

          <div className="about-bio">

            {bio.map((p) => (

              <p key={p}>{p}</p>

            ))}

          </div>

        </div>



        <div className="about-col about-col-facts">

          <ScrambleReveal text="— Facts" className="about-col-label" delay={0.2} externalInView={inView} />

          <dl className="about-facts">

            {ABOUT_FACTS.map(({ label, value, mono, href, openContact }) => (

              <div key={label} className="about-fact">

                <dt>{label}</dt>

                <dd className={mono ? 'mono' : ''}>
                  {openContact ? (
                    <ContactTrigger className="about-fact-email">
                      {value}
                    </ContactTrigger>
                  ) : href ? (
                    <a href={href} className="about-fact-email">
                      {value}
                    </a>
                  ) : (
                    value
                  )}
                </dd>

              </div>

            ))}

          </dl>

        </div>

      </div>

    </section>

  );

};



export default AboutSection;

